module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-bottom-stone-path.ea5178d9.png";